import { grid } from "../../script";

(function ($) {
  if (
    !document.getElementById("sidebar") ||
    $("#sidebar").children().length === 0
  ) {
    return;
  }

  let setSidebarAccessibilityAttrs = (
    $sidebar,
    $sidebarButton,
    $sidebarMenu
  ) => {
    if (!window.matchMedia("(min-width: " + grid.mediumScreen + ")").matches) {
      if ($sidebar.classList.contains("active")) {
        $sidebarButton.setAttribute("aria-expanded", "true");
        $sidebarMenu.setAttribute("aria-hidden", "false");
      } else {
        $sidebarButton.setAttribute("aria-expanded", "false");
        $sidebarMenu.setAttribute("aria-hidden", "true");
      }
    } else {
      $sidebarButton.removeAttribute("aria-expanded");
      $sidebarMenu.removeAttribute("aria-hidden");
    }
  };

  let addScrollToContactButton = ($sidebar) => {
    if (document.getElementById("contact-box")) {
      document
        .getElementById("scroll-to-contact-button")
        .classList.add("active");
    }
  };

  $(document).ready(() => {
    let $sidebar = document.getElementById("sidebar");
    let $sidebarMenu = $sidebar.querySelector("ul");
    let $sidebarButton = $sidebar.querySelector("button");

    if ("undefined" !== typeof sidebar) {
      $sidebarButton.onclick = () => {
        $($sidebarMenu).slideToggle(200);
        let isActive = $sidebar.classList.toggle("active");

        setSidebarAccessibilityAttrs($sidebar, $sidebarButton, $sidebarMenu);
      };
    }

    addScrollToContactButton();

    setSidebarAccessibilityAttrs($sidebar, $sidebarButton, $sidebarMenu);

    $(window).resize(() => {
      setSidebarAccessibilityAttrs($sidebar, $sidebarButton, $sidebarMenu);
    });
  });
})(jQuery);



// WEBPACK FOOTER //
// ./assets/js/components/layout/sidebar.js